export const DEEP_LINK_TYPES = {
  CHALLENGE: 'challenge',
  FRIEND: 'friend',
  GROUP: 'group',
} as const;

export type DeepLinkType = (typeof DEEP_LINK_TYPES)[keyof typeof DEEP_LINK_TYPES];

export interface PendingDeepLink {
  type: DeepLinkType;
  token: string;
  savedAt: number;
}

export interface DeepLinkResolveResponse {
  success: boolean;
  data?: {
    type: DeepLinkType;
    metadata: {
      inviterName?: string;
      challengeName?: string | null;
      groupName?: string;
    };
  };
  error?: string;
}

export interface DeepLinkProcessResponse {
  success: boolean;
  data?: {
    type: DeepLinkType;
    redirectTo: string;
    /** When set, show as a success snackbar after landing on Arena. */
    successMessage?: string;
  };
  error?: string;
}

/** Minimal shape for extracting error messages from axios-like errors. */
export interface AxiosLikeError {
  response?: { data?: { error?: string; message?: string } };
}
